// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import keycode from 'keycode'

class VerseModal extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isOpen: true
		}

		this.root = document.getElementById( 'app-verse-modal' )
		this.el = document.createElement( 'div' )
	}

	static defaultProps = {
		heading: '',
		acceptText: 'OK',
		cancelText: 'Cancel',
		accept: false,
		cancel: false
	}

	componentDidMount() {
		this.root.appendChild( this.el )
		document.documentElement.classList.add( 'with-verse-modal-open' )
		document.addEventListener( 'mousedown', this.handleClickOutside )
		document.addEventListener( 'keydown', this.handleKeyPress )
	}

	componentWillUnmount() {
		this.root.removeChild( this.el )
		document.documentElement.classList.remove( 'with-verse-modal-open' )
		document.removeEventListener( 'mousedown', this.handleClickOutside )
		document.removeEventListener( 'keydown', this.handleKeyPress )
	}

	handleClickOutside = ( e ) => {
		if ( this.outside == e.target ) {
			this.handleCancel()
		}
	}

	handleKeyPress = ( e ) => {
		if ( 'esc' == keycode( e ) ) {
			this.handleCancel()
		}
	}

	handleAccpet = () => {
		this.setState({
			isOpen: false
		})

		setTimeout( () => {
			this.props.accept()
		}, 300 )
	}

	handleCancel = () => {
		this.setState({
			isOpen: false
		})

		setTimeout( () => {
			this.props.handleCancel()
		}, 300 )
	}

	render() {
		const { children, heading, acceptText, cancelText } = this.props
		const { isOpen } = this.state
		const className = isOpen ? 'modal verse-modal is-open' : 'modal verse-modal is-closed'

		const markup = (
			<div className={ className } ref={ ( e ) => { this.outside = e } } tabIndex="0">
				<div className="-inner">
					{ heading &&
						<h4>{ heading }</h4>
					}

					<div className="-text">
						{ children }
					</div>

					<div className="-actions">
						<div className="button -cancel" onClick={ this.handleCancel }>{ cancelText }</div>
					</div>
				</div>
			</div>
		)

		return ReactDOM.createPortal(
			markup,
			this.el
		)
	}
}

export default VerseModal
